import React from 'react'
import {connect} from 'react-redux'

const FriendProfile = (props) => {

        return (
            <div>
                <div className='row'>
                    <h2>profile.</h2>
                </div>
                <div className='row'>
                    <div className='userPhoto'>
                    </div>
                </div>
                <div className='row'>
                    <div className='text-left userProfile'>
                    
                    </div>
                </div>
            </div>
        );
}



export default FriendProfile